const routes = [
  {
    path: '/liftManage',
    name: 'liftManage',
    component: () => import('./view/liftInfo.vue'),
    meta: {
      requireAuth: true,
      routerAlive: false
    }
  }
]

export default routes